export const StudentFlashcardTranslations = {
  TEST: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Tests',
    eus: 'Tests',
    pt: 'Testes'
  },
  COLLECTIONS: {
    es: 'Colecciones',
    en: 'Collections',
    cat: 'Col·leccions',
    eus: 'Kollekzioak',
    pt: 'Coleções'
  },
  CREATE_FLASHCARD: {
    es: 'Crear flashcard',
    en: 'Create flashcard',
    cat: 'Crear flashcard',
    eus: 'Flashcard sortu',
    pt: 'Criar flashcard'
  },
  EDIT_COLLECTION: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  MOVE_TO_COLLECTION: {
    es: 'Mover a otra colección',
    en: 'Move to another collection',
    cat: 'Moure a altra col·lecció',
    eus: 'Ezabatu',
    pt: 'Mover para outra coleção'
  },
  HIDE_FLASHCARD: {
    es: 'Ocultar',
    en: 'Hide',
    cat: 'Ocultar',
    eus: 'Ezabatu',
    pt: 'Ocultar'
  },
  UNHIDE_FLASHCARD: {
    es: 'Mostrar',
    en: 'Show',
    cat: 'Mostrar',
    eus: 'Erakutsi',
    pt: 'Mostrar'
  },
  DELETE_FLASHCARD: {
    es: 'Eliminar',
    en: 'Delete',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Eliminar'
  },
  DELETE_FLASHCARD_CONFIRMATION: {
    es: '¿Estás seguro de querer eliminar esta flashcard?',
    en: 'Are you sure you want to delete this flashcard?',
    cat: 'Estàs segur de voler eliminar aquesta flashcard?',
    eus: 'Ziur al derritzen duzu hau flashcard?',
    pt: 'Tem certeza que deseja excluir esta flashcard?'
  },
  PRACTICE: {
    es: 'Practicar',
    en: 'Practice',
    cat: 'Practicar',
    eus: 'Ezabatu',
    pt: 'Practicar'
  },
  DELETE_COLLECTION: {
    es: 'Eliminar colección',
    en: 'Delete collection',
    cat: 'Eliminar col·lecció',
    eus: 'Kollekzioa ezabatu',
    pt: 'Excluir coleção'
  },
  FLASHCARDS_COUNT: {
    es: '{{count}} flashcards',
    en: '{{count}} flashcards',
    cat: '{{count}} flashcards',
    eus: '{{count}} flashcards',
    pt: '{{count}} flashcards'
  },
  CREATED_WITH_AI: {
    es: 'Creado con IA',
    en: 'Created with AI',
    cat: 'Creat amb IA',
    eus: 'Ikusi IA',
    pt: 'Criado com IA'
  },
  MORE_OPTIONS: {
    es: 'Más opciones',
    en: 'More options',
    cat: 'Més opcions',
    eus: 'Gehiago aukerak',
    pt: 'Mais opções'
  },
  CREATE: {
    es: 'Crear',
    en: 'Create',
    cat: 'Crear',
    eus: 'Sortu',
    pt: 'Criar'
  },
  EDIT: {
    es: 'Actualizar',
    en: 'Update',
    cat: 'Actualitzar',
    eus: 'Eguneratu',
    pt: 'Atualizar'
  },
  CREATE_FLASHCARD_TITLE: {
    es: 'Crear flashcard',
    en: 'Create flashcard',
    cat: 'Crear flashcard',
    eus: 'Flashcard sortu',
    pt: 'Criar flashcard'
  },
  CREATE_FLASHCARDS: {
    es: 'Crear flashcards',
    en: 'Create flashcards',
    cat: 'Crear flashcards',
    eus: 'Flashcards sortu',
    pt: 'Criar flashcards'
  },
  CREATE_FLASHCARD_WITH_AI_TITLE: {
    es: 'Crear flashcard con IA',
    en: 'Create flashcard with AI',
    cat: 'Crear flashcard amb IA',
    eus: 'Flashcard sortu IA gisa',
    pt: 'Criar flashcard com IA'
  },
  EDIT_FLASHCARD_TITLE: {
    es: 'Editar flashcard',
    en: 'Edit flashcard',
    cat: 'Editar flashcard',
    eus: 'Editatu flashcard',
    pt: 'Editar flashcard'
  },
  QUESTION: {
    es: 'Pregunta',
    en: 'Question',
    cat: 'Pregunta',
    eus: 'Galdera',
    pt: 'Pergunta'
  },
  ANSWER: {
    es: 'Respuesta',
    en: 'Answer',
    cat: 'Resposta',
    eus: 'Erantzun',
    pt: 'Resposta'
  },
  ADD_EXPLANATION: {
    es: 'Añadir explicación',
    en: 'Add explanation',
    cat: 'Añadir explicació',
    eus: 'Erantzun gisa',
    pt: 'Adicionar explicação'
  },
  SUBTRACT_POPOVER: {
    es: 'Elimina la explicación',
    en: 'Remove the explanation',
    cat: 'Elimina la explicació',
    eus: 'Ezabatu ezinik',
    pt: 'Remover a explicação'
  },
  EXPLANATION: {
    es: 'Explicación',
    en: 'Explanation',
    cat: 'Explicació',
    eus: 'Erantzun gisa',
    pt: 'Explicação'
  },
  FLASHCARD_TITLE: {
    es: 'Crear flashcards para {{name}}',
    en: 'Create flashcards for {{name}}',
    cat: 'Crear flashcards per {{name}}',
    eus: 'Flashcard sortu {{name}} gisa',
    pt: 'Criar flashcards para {{name}}'
  },
  CREATE_FLASHCARD_TYPE_HANDMADE_TITLE: {
    es: 'Crear a mano',
    en: 'Create handmade',
    cat: 'Crear a mà',
    eus: 'Ezkutu gisa',
    pt: 'Criar de escrita'
  },
  CREATE_FLASHCARD_TYPE_HANDMADE_DESCRIPTION: {
    es: 'Escribe tus propias tarjetas de repaso desde cero.',
    en: 'Write your own flashcards from scratch.',
    cat: 'Escriu les teves pròpies targetes de repàs des de zero.',
    eus: 'Idatzi zure iritzi-txartelak hutsetik.',
    pt: 'Escreva as suas próprias flashcards de zero.'
  },
  CREATE_FLASHCARD_TYPE_AI_TITLE: {
    es: 'Crear con IA',
    en: 'Create with AI',
    cat: 'Crear amb IA',
    eus: 'Flashcard sortu IA gisa',
    pt: 'Criar com IA'
  },
  CREATE_FLASHCARD_TYPE_AI_DESCRIPTION: {
    es: 'Genera tarjetas de repaso en segundos con la IA.',
    en: 'Generate flashcards in seconds with the AI.',
    cat: 'Genera targetes de repàs en segons amb la IA.',
    eus: 'Sortu flash-txartelak segundotan IA-rekin.',
    pt: 'Crie flashcards em segundos com IA.'
  },
  DELETE_COLLECTION_CONFIRMATION: {
    es: '¿Estás seguro de querer eliminar esta colección?',
    en: 'Are you sure you want to delete this collection?',
    cat: 'Estàs segur de voler eliminar aquesta col·lecció?',
    eus: 'Ziur al derritzen duzu hau kollekzioa?',
    pt: 'Tem certeza que deseja excluir esta coleção?'
  },
  MOVE_FLASHCARD_TITLE: {
    es: 'Mover flashcard a otra colección',
    en: 'Move flashcard to another collection',
    cat: 'Moure flashcard a altra col·lecció',
    eus: 'Ezabatu flashcard kollekzio batetik',
    pt: 'Mover flashcard para outra coleção'
  },
  MOVE: {
    es: 'Mover',
    en: 'Move',
    cat: 'Moure',
    eus: 'Ezabatu',
    pt: 'Mover'
  },
  SELECT_COLLECTION: {
    es: 'Selecciona la colección',
    en: 'Select collection',
    cat: 'Selecciona la col·lecció',
    eus: 'Kollekzioa hautatu',
    pt: 'Seleciona a coleção'
  },
  CREATE_COLLECTION: {
    es: 'Crear nueva colección',
    en: 'Create new collection',
    cat: 'Crear nova col·lecció',
    eus: 'Ezabatu kollekzioa',
    pt: 'Criar nova coleção'
  },
  THIS_WILL_CREATE_FLASHCARDS: {
    es: 'Esto creará {{count}} flashcards por cada tema',
    en: 'This will create {{count}} flashcards for each topic',
    cat: 'Això crearà {{count}} flashcards per cada tema',
    eus: 'Honek {{count}} flashcard sortuko ditu gai bakoitzeko',
    pt: 'Isso criará {{count}} flashcards para cada tópico'
  },
  SELECT_UP_TO: {
    es: 'Elige hasta {{count}} temas',
    en: 'Choose up to {{count}} topics',
    cat: 'Escolliu fins a {{count}} temes',
    eus: 'Aukeratu gehienez {{count}} gai',
    pt: 'Escolha até {{count}} temas'
  },
  GENERATING_FLASHCARDS: {
    es: 'Generando flashcards...',
    en: 'Generating flashcards...',
    cat: 'Generant flashcards...',
    eus: 'Flashcard sortzea...',
    pt: 'Gerando flashcards...'
  },
  GENERATING_FLASHCARDS_SUBTITLE: {
    es: 'Esto puede tardar unos segundos.',
    en: 'This may take a few seconds.',
    cat: 'Això pot tardar uns segons.',
    eus: 'Baliteke segundo batzuk behar izatea',
    pt: 'Isto pode levar alguns segundos.'
  },
  SEARCH_SECTION: {
    es: 'Buscar sección',
    en: 'Search section',
    cat: 'Buscar secció',
    eus: 'Ezabatu gai bat',
    pt: 'Pesquisar seção'
  },
  PREVIEW: {
    es: 'Previsualizar',
    en: 'Preview',
    cat: 'Previsualitzar',
    eus: 'Erakutsi',
    pt: 'Pré-visualizar'
  },
  EDIT_MARKDOWN: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Eguneratu',
    pt: 'Atualizar'
  },
  NO_COLLECTIONS_FOUND: {
    es: 'No se encontraron colecciones con el mismo curso.',
    en: 'No collections found with the same course.',
    cat: 'No s’han trobat col·leccions amb el mateix curs.',
    eus: 'Ez da ikastaro berdina duten bildumarik aurkitu.',
    pt: 'Não foram encontradas coleções com o mesmo curso.'
  },
  NO_RESOURCES_FOUND: {
    es: 'No hay material suficiente sobre los temas de esta colección sobre el que generar flashcards.',
    en: 'No enough resources found on the topics of this collection to generate flashcards.',
    cat: 'No hi ha prou material sobre els temes d’aquesta col·lecció per generar targetes de repàs.',
    eus: 'Ez dago bilduma honetako gaietan oinarrituta flashcard-ak sortzeko adina materialik.',
    pt: 'Não há material suficiente sobre os tópicos desta coleção para gerar flashcards.'
  },
  PRACTICE_COLLECTION: {
    es: 'Practicar colección',
    en: 'Practice collection',
    cat: 'Practicar col·lecció',
    eus: 'Kollekzioa ezkutatu',
    pt: 'Practicar coleção'
  }
};
